import React, { useState, useEffect, useContext, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { signOut } from 'firebase/auth';
import { auth } from './login/FirebaseConfig';
import { AuthContext } from './login/AuthContext';
import '../css/Navbar2.css';

const NavbarInicial = () => {
  const [secciones, setSecciones] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const currentUrl = location.pathname;
  const lastCrossedRef = useRef(null);
  const [lastCrossedId, setLastCrossedId] = useState(null);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error('Error al cerrar sesión ', err);
    }
  };

  const scrollToSection = (id) => {
    const section = document.querySelector(id);
    if (section) {
      const navbar = document.querySelector('.navbar');
      const offset = navbar ? navbar.offsetHeight : 0; // Obtiene el tamaño del navbar segun el dispositivo
      const sectionPosition = section.offsetTop - offset; // hace offset segun el tamaño del navbar

      window.scrollTo({
        top: sectionPosition,
        behavior: 'smooth',
      });
    }
  };

  const isActiveLink = (link) => {
    return currentUrl === link ? 'actual-link' : '';
  };

  const handleNavLinkClick = (e, sectionId) => {
    e.preventDefault();
    setExpanded(false); // Colapsa el navbar al clickear un navlink

    const sanitizedId = sectionId.replace(/\s+/g, '');
    if (currentUrl === '/') {
      scrollToSection(`${sanitizedId}`);
    } else {
      navigate('/');
      scrollToSection(`${sanitizedId}`);
    }
  };

  // Funcion para trackear el elemento actual en pantalla
  const trackLastCrossedElement = () => {
    const checkLastCrossedElement = () => {
      const elements = document.querySelectorAll('[id]');
      let lastElement = null;

      elements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        if (rect.top <= window.innerHeight / 3 && rect.bottom >= window.innerHeight / 3) {
          lastElement = element;
        }
      });

      if (lastElement && lastCrossedRef.current !== lastElement) {
        lastCrossedRef.current = lastElement;
        let newId;
        // Mapeo de ids
        if (lastElement.id === "mapaUbicacion") {
          newId = "ubicacion";
        } else if (lastElement.id === "noticiasfeed") {
          newId = "redes";
        } else {
          newId = lastElement.id;
        }
        setLastCrossedId(newId);
      }
    };

    window.addEventListener('scroll', checkLastCrossedElement);
    checkLastCrossedElement();

    return () => {
      window.removeEventListener('scroll', checkLastCrossedElement);
    };
  };

  useEffect(() => {
    trackLastCrossedElement();
  }, []);

  return (
    <Navbar expand="xl" className="casino-navbar navbar-dark sticky-top" expanded={expanded} id="navbar-inicial">
      <Container fluid className='px-md-5'>
        <Navbar.Brand href="/" className="text-gold">
          <div className={lastCrossedId === 'inicio' || lastCrossedId === 'info-container' ? 'logo-active-link' : 'logo-inactive-link'}>
            <img
              id="logo-lg"
              src="/imagenes/Logos/logoverticalblanco3.png"
              alt="Logo Bingo Bahia"
              style={{ height: '75px', width: 'auto' }}
              onClick={(e) => handleNavLinkClick(e, '#inicio')}
            />
            <img
              id="logo-sm"
              src="/imagenes/Logos/logoverticalblanco3.png"
              alt="Logo Bingo Bahia"
              style={{ height: '55px', width: 'auto' }}
              onClick={(e) => handleNavLinkClick(e, '#inicio')}
            />
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link
              className={`text-gold ${lastCrossedId === 'container-experiencia' ? 'navlink-highlighted' : ''} ${isActiveLink('/explicacioneventos')}`}
              onClick={(e) => handleNavLinkClick(e, '#container-experiencia')}
              style={{ cursor: 'pointer' }}
            >
              EXPERIENCIA
            </Nav.Link>
            <Nav.Link
              className={`text-gold ${lastCrossedId === 'gastronomia' ? 'navlink-highlighted' : ''} ${isActiveLink('/explicacioneventos')}`}
              onClick={(e) => handleNavLinkClick(e, '#gastronomia')}
              style={{ cursor: 'pointer' }}
            >
              GASTRONOMÍA
            </Nav.Link>
            <Nav.Link
              className={`text-gold ${lastCrossedId === 'cashless' ? 'navlink-highlighted' : ''} ${isActiveLink('/cashless')}`}
              onClick={(e) => handleNavLinkClick(e, '#cashless')}
              style={{ cursor: 'pointer' }}
            >
              CASHLESS
            </Nav.Link>
            <Nav.Link
              className={`text-gold ${lastCrossedId === 'ubicacion' ? 'navlink-highlighted' : ''} ${isActiveLink('/explicacioneventos')}`}
              onClick={(e) => handleNavLinkClick(e, '#ubicacion')}
              style={{ cursor: 'pointer' }}
            >
              UBICACIÓN
            </Nav.Link>
            <Nav.Link
              className={`text-gold ${lastCrossedId === 'redes' ? 'navlink-highlighted' : ''} ${isActiveLink('/explicacioneventos')}`}
              onClick={(e) => handleNavLinkClick(e, '#redes')}
              style={{ cursor: 'pointer' }}
            >
              REDES
            </Nav.Link>
            <Nav.Link
              className={`text-gold ${lastCrossedId === 'eventos' ? 'navlink-highlighted' : ''} ${isActiveLink('/explicacioneventos')}`}
              onClick={(e) => handleNavLinkClick(e, '#eventos')}
              style={{ cursor: 'pointer' }}
            >
              SHOWS Y EVENTOS
            </Nav.Link>
            {secciones.length > 0 ? (
              secciones.map((seccion, index) => (
                <Nav.Link
                  key={index}
                  onClick={(e) => handleNavLinkClick(e, `#${seccion.id}`)}
                  className={`text-gold ${lastCrossedId === seccion.id.replace(/\s+/g, '') ? 'navlink-highlighted' : ''} ${isActiveLink(`/${seccion.id}`)}`}
                >
                  {seccion.id}
                </Nav.Link>
              ))
            ) : null}
            {user && (
              <Nav.Link
                className={`text-gold ${isActiveLink('/PanelDeControl')}`}
                href="/PanelDeControl"
                style={{ cursor: 'pointer' }}
              >
                PANEL DE CONTROL
              </Nav.Link>
            )}
            {user && (
              <Nav.Link
                className="text-gold"
                onClick={handleLogout}
                style={{ cursor: 'pointer' }}
              >
                CERRAR SESIÓN
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarInicial;
